<script lang="ts">
  import Container from "./Container.svelte";
  import type { Justify, Spacing } from "./types.ts";
  export let gap: Spacing | undefined = undefined;
  export let justify: Justify | undefined = undefined;
  export let margin: Spacing | undefined = undefined;
  export let mobileMargin: Spacing | undefined = undefined;
  export let wrap = false;
  export let outset: boolean | "m" = false;
  export let full = false;
</script>

<Container
  direction="row"
  {wrap}
  {gap}
  {justify}
  {margin}
  {mobileMargin}
  {outset}
  {full}
><slot /></Container>
